export default {
  onlyNumber($event) {
    const keyCode = ($event.keyCode ? $event.keyCode : $event.which)
    if (keyCode < 48 || (keyCode > 57 && keyCode < 96) || keyCode > 105) {
      $event.preventDefault()
    }
  }
}
